import { useEffect } from "react";
import "./App.css";
import Router from "./routes/Router";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { setUser } from "./state/reducers/userSlice";
import { QuizProvider } from "./context/QuizContext";

import { Toaster } from "react-hot-toast";
import { WebSocketProvider } from "./state/reducers/WebSocketProvider";

function App() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      dispatch(setUser(decoded));
    }
  }, [token]);
  return (
    <>
      <WebSocketProvider>
        <QuizProvider>
          <Toaster position="top-center" reverseOrder={false} />
          <Router />
        </QuizProvider>
      </WebSocketProvider>
    </>
  );
}

export default App;
